import {MARKET} from "../config";

export const getAutomatPrice = (year) => {
    switch (MARKET) {
        case 'en':
            return year ? 54.99 : 69.99;

        case 'hu':
            return year ? 9449.99 : 11799.99;

        case 'pl':
            return year ? 101.99 : 126.99;

        case 'ro':
            return year ? 121.99 : 149.99;

        case 'cz':
            return year ? 589 : 739;

        default:
            return year ? 23.99 : 29.99;
    }
};
